import { IProviderInfo } from '../../helpers';

export const FALLBACK: IProviderInfo = {
  id: 'injected',
  name: 'Web3',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/web3-default.svg',
  type: 'injected',
  check: 'isWeb3',
};

export const METAMASK: IProviderInfo = {
  id: 'injected',
  name: 'MetaMask',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/metamask.svg',
  type: 'injected',
  check: 'isMetaMask',
};

export const SAFE: IProviderInfo = {
  id: 'injected',
  name: 'Safe',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/safe.svg',
  type: 'injected',
  check: 'isSafe',
};

export const NIFTY: IProviderInfo = {
  id: 'injected',
  name: 'Nifty',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/niftyWallet.png',
  type: 'injected',
  check: 'isNiftyWallet',
};

export const DAPPER: IProviderInfo = {
  id: 'injected',
  name: 'Dapper',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/dapper.png',
  type: 'injected',
  check: 'isDapper',
};

export const OPERA: IProviderInfo = {
  id: 'injected',
  name: 'Opera',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/opera.svg',
  type: 'injected',
  check: 'isOpera',
};

export const TRUST: IProviderInfo = {
  id: 'injected',
  name: 'Trust',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/trust.svg',
  type: 'injected',
  check: 'isTrust',
};

export const COINBASE: IProviderInfo = {
  id: 'injected',
  name: 'Coinbase',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/coinbase.svg',
  type: 'injected',
  check: 'isToshi',
};

export const CIPHER: IProviderInfo = {
  id: 'injected',
  name: 'Cipher',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/cipher.svg',
  type: 'injected',
  check: 'isCipher',
};

export const IMTOKEN: IProviderInfo = {
  id: 'injected',
  name: 'imToken',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/imtoken.svg',
  type: 'injected',
  check: 'isImToken',
};

export const STATUS: IProviderInfo = {
  id: 'injected',
  name: 'Status',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/status.svg',
  type: 'injected',
  check: 'isStatus',
};

export const TOKENARY: IProviderInfo = {
  id: 'injected',
  name: 'Tokenary',
  logo: 'https://cdn-assets.minds.com/web3modal-assets/tokenary.png',
  type: 'injected',
  check: 'isTokenary',
};

export const RABBY: IProviderInfo = {
  id: 'injected',
  name: 'Rabby',
  logo: 'https://raw.githubusercontent.com/RabbyHub/logo/refs/heads/master/symbol-white.png',
  type: 'injected',
  check: 'isRabby',
};
